module.exports = __webpack_public_path__ + "static/1984-0dc16e3d4b1862ed887ab418637823e5.png";